var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"mt-5"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h2',[_vm._v("Connexion en cours...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }